
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import mixins from 'vue-typed-mixins';

import { formatNumber } from '@/i18n';

import Ad from '@/store/modules/ads/ad';
import { AdStatus } from '@/store/modules/ads/ad';
import { AdsActions } from '@/store/modules/ads/types';

import CheckboxControl from '@/components/controls/checkbox.vue';
import tableViewMixin from '@/components/mixins/table-view';
import NotificationBanner from '@/components/blocks/notification-banner.vue';
import TableListSkeleton from '@/components/skeletons/table-list.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import PaginationControl from '@/components/controls/pagination.vue';
import AdsFilter from '@/components/forms/ads-filter.vue';
import AdClickStats from '@/components/blocks/ad-click-stats.vue';

export default mixins(tableViewMixin).extend({
  name: 'AdsView',
  components: {
    NotificationBanner,
    TableListSkeleton,
    Dropdown,
    PaginationControl,
    AdsFilter,
    CheckboxControl,
    AdClickStats,
  },
  data() {
    return {
      selectedItems: [],
      AdStatus,
    };
  },
  computed: {
    ...mapGetters('user/profile', ['isSuperAdmin', 'isAdmin']),
    ...mapState('ads', {
      ads: 'list',
      pagination: 'listPagination',
    }),
    ...mapGetters('ads', {
      isLoading: 'listIsLoading',
      isLoaded: 'listIsLoaded',
      isEmpty: 'listIsEmpty',
    }),
    areAllItemsSelected(): boolean {
      return this.selectedItems.length === this.ads.length;
    },
  },
  methods: {
    formatNumber,
    ...mapActions('ads', {
      restoreAction: AdsActions.RESTORE,
      removeAd: AdsActions.DELETE,
    }),
    dropdownItems(ad: Ad) {
      const items: DropdownItems = {
        edit: {
          label: this.$t('Edit'),
          icon: 'pencil',
        },
      };

      if (ad.status === this.AdStatus.Inactive) {
        items.restore = {
          label: this.$t('Restore'),
          icon: 'restore',
        };
      } else {
        items.delete = {
          label: this.$t('Delete'),
          icon: 'delete',
        };
      }

      return items;
    },
    handleClick(ad: Ad, action: string) {
      if ('edit' === action) {
        this.$router.push({
          name: 'edit-ad',
          params: { id: String(ad.id) },
        });
      }

      if ('restore' === action) {
        const answer = window.confirm(this.$t('Do you really want to restore this ad?'));

        if (answer) {
          this.restoreAction({ id: ad.id });
        }
      }

      if ('delete' === action) {
        const answer = window.confirm(this.$t('Do you really want to delete this ad?'));

        if (answer) {
          this.removeAd({ id: ad.id });
        }
      }
    },
    isSelected(ad: Ad): boolean {
      return this.selectedItems.indexOf(ad.id) !== -1;
    },
    selectItem(ad: Ad) {
      if (this.isSelected(ad)) {
        this.selectedItems = this.selectedItems.filter((item) => item !== ad.id);
        return;
      }

      this.selectedItems.push(ad.id);
    },
    selectAll() {
      if (this.areAllItemsSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.ads.map((ad: Ad) => ad.id);
      }
    },
  },
});
